import { runInAction, decorate, observable, toJS, action } from "mobx";
import {
  getAllGatewaySMS,
  addGatewaySMS,
  getAllInboxList,
  getAllInboxFilterList,
  getExportBulkLogList,
  rescheduleMessage,
  cancelScheduleMessage,
  getRetailChatInboxList,
  getAllInboxFilterListOld,
  addBulkForMultiGroup,
  hideConversation,
  unhideConversation
} from "service/gatewayService";

class ObservableGatewayStore {
  gatewaySMSList = [];
  addGatewaySMSResponse = undefined;
  total = 0;
  pageSize = 10;
  current = 1;
  search = undefined;
  sortField = "createdAt";
  sortOrder = "descend";
  showNewCreateMessageAlert = false;
  gatewaySMSBulkList = [];
  exportLogList = [];
  response = undefined;

  // using for inbox messaging
  listSize = 10; // pageSize
  listItem = 1; // current
  totalItems = 0; // total
  listLenght = 0; // legacy; prefer inboxHasMore for infinite scroll
  hasNextPage = false;
  inboxNextCursor = null;
  inboxHasMore = false;
  latestInboxRequestId = 0; // Track latest request to prevent race conditions

  changeSorting = fieldObj => {
    runInAction(() => {
      const { field, sortOrder } = fieldObj;
      this.sortField = field;
      this.sortOrder = sortOrder;
    });
  };

  setSearch = search => {
    runInAction(() => {
      this.search = search;
    });
  };

  setPage = current => {
    runInAction(() => {
      this.current = current || 1;
    });
  };

  setListItem = currentItem => {
    runInAction(() => {
      this.listItem = currentItem || 1;
      if (this.listItem === 1) {
        this.inboxNextCursor = null;
        this.inboxHasMore = false;
      }
    });
  };

  resetInboxPagination = () => {
    runInAction(() => {
      this.listItem = 1;
      this.inboxNextCursor = null;
      this.inboxHasMore = false;
      this.hasNextPage = false;
      this.gatewaySMSBulkList = [];
    });
  };

  /** Reset page cursor without clearing the visible inbox list (soft refresh). */
  resetInboxCursorOnly = () => {
    runInAction(() => {
      this.listItem = 1;
      this.inboxNextCursor = null;
      this.inboxHasMore = false;
      this.hasNextPage = false;
    });
  };

  /**
   * get all Users
   * @returns {Promise<[]>}
   */
  getAllGatewaySMS = async args => {
    // call & save User list response
    const params = {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      ...(args && args)
    };

    if (this.search) {
      for (var key of Object.keys(this.search)) {
        if (this.search[key]) {
          params[key] = this.search[key];
        }
      }
    }
    const getAllGatewaySMSResponse = await getAllGatewaySMS(params);
    try {
      runInAction(() => {
        const { items, total, current, limit: pageSize } = getAllGatewaySMSResponse;
        this.gatewaySMSList = items;
        this.pageSize = pageSize;
        this.current = current;
        this.total = total;
      });
    } catch (error) {
      runInAction(() => {
        this.status = "error";
      });
    }

    return this.gatewaySMSList;
  };

  /**
   * add new User
   * @param userData
   * @returns {Promise<*>}
   */
  addGatewaySMS = async gatewaySMSData => {
    // call api for add new User
    const method = gatewaySMSData?.group_array ? addBulkForMultiGroup : addGatewaySMS;
    const addGatewaySMSResponse = await method(gatewaySMSData);
    try {
      runInAction(() => {
        this.addGatewaySMSResponse = addGatewaySMSResponse;
      });
    } catch (error) {
      runInAction(() => {
        this.addGatewaySMSResponse = error;
      });
    }
    return this.addGatewaySMSResponse;
  };

  // addGatewayMMS = async data => {
  //   // call api for add new User
  //   const addGatewaySMSResponse = await addGatewayMMS(data);
  //   try {
  //     runInAction(() => {
  //       this.addGatewaySMSResponse = addGatewaySMSResponse;
  //     });
  //     this.getAllGatewaySMS({ isMMS: true });
  //   } catch (error) {
  //     runInAction(() => {
  //       this.addGatewaySMSResponse = error;
  //     });
  //   }
  //   return this.addGatewaySMSResponse;
  // };

  updateMessageStatus = async statusObj => {
    try {
      runInAction(() => {
        const findGatewayMessageIndex = this.gatewaySMSList.findIndex(x => x._id === statusObj._id);
        if (findGatewayMessageIndex > -1) {
          const tempMessageObj = {
            ...this.gatewaySMSList[findGatewayMessageIndex]
          };
          tempMessageObj.status = statusObj.status;
          this.gatewaySMSList.slice(findGatewayMessageIndex, 1);
          const tempGatewaySMSList = [...this.gatewaySMSList];
          tempGatewaySMSList[findGatewayMessageIndex].status = statusObj.status;
          this.gatewaySMSList = tempGatewaySMSList;
        } else if (this.current === 1 && this.search === undefined) {
          //for received sms,put then in first
          statusObj.createdAt = new Date(statusObj.createdAt).toLocaleString();
          this.gatewaySMSList = [statusObj, ...this.gatewaySMSList];
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  deleteMessageStatus = async data => {
    try {
      runInAction(() => {
        const filteredMessageList = this.gatewaySMSList.filter(item => item._id !== data._id);
        this.gatewaySMSList = filteredMessageList;
      });
    } catch (error) {
      console.log(error);
    }
  };

  addMessageToGatewayList = async messageObj => {
    const insertMessageObj = {
      ...messageObj,
      createdAt: new Date(messageObj.createdAt).toLocaleString()
    };
    try {
      runInAction(() => {
        const tempMessageList = [...this.gatewaySMSList];
        if (tempMessageList.length >= 50) {
          tempMessageList.pop();
        }
        this.gatewaySMSList = [insertMessageObj].concat(tempMessageList);
      });
    } catch (error) {
      console.log(error);
    }
    return this.gatewaySMSList;
  };

  setshowNewCreateMessageAlert = () => {
    runInAction(() => {
      this.showNewCreateMessageAlert = !this.showNewCreateMessageAlert;
    });
  };

  /**
   * Real-time chat list update for an inbound reply.
   *
   * Called from `utils/socket/index.js` when the backend emits
   * `newReplyMessage`. We:
   *  1) Find the existing conversation in `gatewaySMSBulkList` (by receiver)
   *     and MERGE the incoming row into it, so we preserve fields the
   *     watcher payload doesn't have (e.g. `contact[]`, prior `totalUnread`).
   *  2) Only mark unread / bump the badge if the user is NOT currently
   *     viewing this conversation (passed in as `opts.isViewingThisChat`).
   *  3) Move the merged row to the top of the list so the most recent
   *     activity floats up — same UX as the inbox API.
   *
   * @param {Object} messageObj           Socket payload, must have `listObj.receiver`
   * @param {Object} [opts]
   * @param {boolean} [opts.isViewingThisChat]
   */
  newMessageEvent = (messageObj, opts = {}) => {
    try {
      const incoming = messageObj?.listObj;
      if (!incoming?.receiver) return;

      runInAction(() => {
        const existingIdx = this.gatewaySMSBulkList.findIndex(_ => _?.receiver === incoming.receiver);
        const existing = existingIdx > -1 ? this.gatewaySMSBulkList[existingIdx] : null;

        const merged = {
          ...(existing || {}),
          ...incoming,
          name: incoming.name || existing?.name || "",
          unread: opts.isViewingThisChat ? false : true,
          totalUnread: opts.isViewingThisChat ? existing?.totalUnread || 0 : (existing?.totalUnread || 0) + 1
        };

        const rest = existingIdx > -1 ? this.gatewaySMSBulkList.filter((_, i) => i !== existingIdx) : [...this.gatewaySMSBulkList];

        this.gatewaySMSBulkList = [merged, ...rest];
      });
    } catch (error) {
      console.log(error);
    }
  };

  readMessage = data => {
    runInAction(() => {
      if (data?.unread) this.gatewaySMSBulkList.find(item => item.message_id === data?.message_id).unread = false;
    });
  };

  setConversationUnread = receiver => {
    runInAction(() => {
      const item = this.gatewaySMSBulkList.find(i => i.receiver === receiver);
      if (item) item.unread = true;
    });
  };

  setConversationRead = receiver => {
    runInAction(() => {
      const item = this.gatewaySMSBulkList.find(i => i.receiver === receiver);
      if (item) item.unread = false;
    });
  };

  /**
   * Close / hide a conversation. Calls the backend to persist the hide and
   * optimistically removes it from the local inbox list. The conversation
   * (and its full history) reappears automatically the next time a message
   * is sent or received for the same number.
   */
  hideConversation = async receiver => {
    if (!receiver) return;
    try {
      await hideConversation({ receiver });
      runInAction(() => {
        this.gatewaySMSBulkList = (this.gatewaySMSBulkList || []).filter(i => i.receiver !== receiver);
        if (this.totalItems > 0) this.totalItems -= 1;
        // Keep pagination metadata in sync with the optimistic remove so the
        // chat list's InfiniteScroll does not keep advertising "more to load"
        // (and rendering its perpetual loader stub) after the dataset has
        // already shrunk to fit within the pages we already have.
        if (this.gatewaySMSBulkList.length === 0) {
          this.inboxHasMore = false;
          this.inboxNextCursor = null;
          this.hasNextPage = false;
        }
      });
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  unhideConversation = async receiver => {
    if (!receiver) return;
    try {
      await unhideConversation({ receiver });
    } catch (error) {
      console.log(error);
    }
  };

  /*
   *Gateway SMS List
   */
  getAllInboxList = async args => {
    const method = args?.retailChat ? getRetailChatInboxList : getAllInboxList;
    const append = !!args?.append;
    const searchTerm = typeof args?.search === "string" ? args.search.trim() : "";

    // Increment request ID to track this specific request
    this.latestInboxRequestId++;
    const currentRequestId = this.latestInboxRequestId;

    const params = {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      limit: this.listSize,
      ...(args && args)
    };
    delete params.append;
    delete params.page;

    if (!args?.retailChat) {
      if (append && this.inboxNextCursor) {
        params.cursor = this.inboxNextCursor;
      }
    } else {
      params.page = this.listItem;
    }

    if (this.search) {
      for (var key of Object.keys(this.search)) {
        if (this.search[key]) {
          params[key] = this.search[key];
        }
      }
    }

    const getAllInboxListResponse = await method(params);

    if (currentRequestId !== this.latestInboxRequestId) {
      return this.gatewaySMSBulkList;
    }

    try {
      runInAction(() => {
        if (args?.retailChat) {
          return (this.gatewaySMSBulkList = getAllInboxListResponse);
        }

        const { items = [], hasMore, nextCursor, cursorReset } = getAllInboxListResponse;
        const pageSize = params.limit || this.listSize;

        if (append) {
          this.gatewaySMSBulkList = [...(this.gatewaySMSBulkList || []), ...items];
          this.listItem = this.listItem + 1;
        } else {
          this.gatewaySMSBulkList = items;
          this.listItem = 1;
        }

        this.listSize = pageSize;
        this.inboxHasMore = !!hasMore;
        this.inboxNextCursor = cursorReset ? null : nextCursor || null;
        this.hasNextPage = !!hasMore;
        this.listLenght = hasMore ? this.listItem + 1 : this.listItem;
        this.totalItems = this.gatewaySMSBulkList.length;
        this.pageSize = pageSize;
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.status = "error";
      });
    }
    return this.gatewaySMSBulkList;
  };

  getAllInboxFilterList = async args => {
    const append = !!args?.append;
    const params = {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      limit: this.listSize,
      ...(args && args)
    };
    delete params.append;
    delete params.page;

    if (!args?.retailChat) {
      if (append && this.inboxNextCursor) {
        params.cursor = this.inboxNextCursor;
      }
    } else {
      params.page = this.listItem;
    }

    const getAllInboxFilterListResponse = args?.retailChat ? await getAllInboxFilterListOld(args?.campaignId) : await getAllInboxFilterList(params);

    try {
      runInAction(() => {
        if (args?.retailChat) {
          const { items, total, current, limit: pageSize, totalPages, hasNextPage } = getAllInboxFilterListResponse;
          this.gatewaySMSBulkList = items;
          this.listSize = pageSize;
          this.listItem = current;
          this.totalItems = total;
          this.listLenght = totalPages;
          this.hasNextPage = hasNextPage;
          return;
        }

        const { items = [], hasMore, nextCursor } = getAllInboxFilterListResponse;
        const pageSize = params.limit || this.listSize;

        if (append) {
          this.gatewaySMSBulkList = [...(this.gatewaySMSBulkList || []), ...items];
          this.listItem = this.listItem + 1;
        } else {
          this.gatewaySMSBulkList = items;
          this.listItem = 1;
        }

        this.listSize = pageSize;
        this.inboxHasMore = !!hasMore;
        this.inboxNextCursor = nextCursor || null;
        this.hasNextPage = !!hasMore;
        this.listLenght = hasMore ? this.listItem + 1 : this.listItem;
        this.totalItems = this.gatewaySMSBulkList.length;
      });
    } catch (error) {
      runInAction(() => {
        console.log(error);
        this.status = "error";
      });
    }
  };

  getExportLogList = async params => {
    const exportLogListResponse = await getExportBulkLogList(params);
    try {
      runInAction(() => {
        this.exportLogList = exportLogListResponse;
      });
    } catch (error) {
      runInAction(() => {
        this.status = "error";
      });
    } finally {
      return this.exportLogList;
    }
  };

  rescheduleMessage = async (id, data) => {
    const response = await rescheduleMessage(id, data);
    try {
      runInAction(() => {
        this.response = response;
        if (response.status) {
          this.gatewaySMSList = this.gatewaySMSList.map(item => {
            if (item._id === id) {
              item.scheduleAt = data.scheduleAt;
            }
            return item;
          });
        }
      });
    } catch (error) {
      runInAction(() => {
        this.response = error;
      });
    }
    return this.response;
  };

  cancelScheduleMessage = async id => {
    const response = await cancelScheduleMessage(id);
    try {
      runInAction(() => {
        this.response = response;
        console.log(response);
        if (response.status) {
          this.gatewaySMSList = this.gatewaySMSList.map(item => {
            if (item._id === id) {
              item.status = "cancel_schedule";
            }
            return item;
          });
        }
      });
    } catch (error) {
      runInAction(() => {
        this.response = error;
      });
    }
    return this.response;
  };
}

decorate(ObservableGatewayStore, {
  readMessage: action,
  hideConversation: action,
  unhideConversation: action,
  resetInboxPagination: action,
  resetInboxCursorOnly: action,
  gatewaySMSList: observable,
  addGatewaySMSResponse: observable,
  pageSize: observable,
  current: observable,
  total: observable,
  listSize: observable, // pageSize
  listItem: observable, // current
  totalItems: observable, // total
  listLenght: observable, // totalPages
  hasNextPage: observable,
  inboxNextCursor: observable,
  inboxHasMore: observable,
  sortField: observable,
  sortOrder: observable,
  search: observable,
  showNewCreateMessageAlert: observable,
  gatewaySMSBulkList: observable,
  exportLogList: observable,
  response: observable
});
export default new ObservableGatewayStore();
